import React from 'react';
import { useIntl } from 'react-intl';
// eslint-disable-next-line import/no-unresolved
import { Content } from '@plone/types';
import { Footer as DSFooter } from '@designsystem/stories/04-organisms/Footer';
import { NavItem } from '@fhnw/types/navItem';
import { useFilteredLogos } from './useFilteredLogos';
import { buildFooterArgs } from './Footer.helpers';

interface LanguageItem {
  ['@id']: string;
  language: string;
}

interface NavContent extends Omit<Content, '@components'> {
  '@components'?: {
    meta?: NavItem;
    footer?: NavItem;
    newsletter?: NavItem;
    translations?: { items: LanguageItem[] };
    university?: Content;
  };
}

interface FooterProps {
  content?: NavContent;
}

/**
 * Footer component for the FHNW website.
 * Displays navigation, logos, language switcher, and newsletter signup.
 *
 * @param {FooterProps} props - Component props
 * @param {NavContent} props.content - Content from Plone CMS including navigation and translations
 *
 * @example
 * <Footer content={ploneContent} />
 */
const Footer: React.FC<FooterProps> = React.memo(({ content }) => {
  const intl = useIntl();
  const filteredLogos = useFilteredLogos(content);
  const args = buildFooterArgs(intl, content, filteredLogos);

  return <DSFooter {...args} />;
});

Footer.displayName = 'Footer';

export default Footer;
